module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_05.91183f51.svg";